import { AzureSearchRequest } from './azure-search-request.model';

export class SearchContext {
    facets: any;
    nextPageParameters: AzureSearchRequest;
}
